<template>
    <v-modal-slot id="change-task-status-modal"
                  @accepted="editTaskStatus">
        <template v-slot:modal-title>
            Cambiar estado
        </template>

        <template v-slot:modal-content>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label class="form-label">Estado: </label>

                        <select class="form-select" aria-label="Estado de la tarea" v-model="selected_task.status">
                            <option value="Abierta">Abierta</option>
                            <option value="Agente asignado">Agente asignado</option>
                            <option value="En proceso de resolución">En proceso de resolución</option>
                            <option value="Cerrada">Cerrada</option>
                        </select>
                    </div>
                </div>
            </div>
        </template>

        <template v-slot:accept-button>
            Guardar
        </template>

        <template v-slot:close-button>
            Cerrar
        </template>
    </v-modal-slot>
</template>

<script>

import VModalSlot from "../../general/VModalSlot";
import VModal from "../../general/VModal";
import {updateTaskStatus} from "../../../helpers/requests/RequestsTasks";

export default {
    name: "TaskChangeStatusModal",
    components: {
        VModalSlot,
        VModal
    },
    data() {
        return {
            selected_task: {},
        }
    },
    props: {
        task: {
            type: Object,
            required: false,
        }
    },
    async mounted() {
        this.selected_task = {...this.task};
    },
    methods: {
        async editTaskStatus() {
            try {
                this.$store.dispatch('app/setToastMessage', 'Cambiando el estado...');

                await updateTaskStatus(this.selected_task.id, this.selected_task);

                this.$store.dispatch('app/setToastMessage', 'Estado cambiado con éxito');

                this.$emit('task-status-updated');

                this.closeModal();
            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al asignar la tarea');
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    },
}
</script>
